import React from 'react'
import Upload from '../Components/Upload/Upload'

const UploadView = () => {
  return (
    <div>
        <Upload/>
    </div>
  )
}

export default UploadView